import { support } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getSupportOptions(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(support.options, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getSupportList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(support.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTicketView(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${support.base}${id}/view/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  // getSupportObject(id) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .get(`${support.base}${id}/`)
  //       .then((res) => {
  //         resolve(handleResponse(res));
  //       })
  //       .catch((err) => {
  //         reject(handleError(err));
  //       });
  //   });
  // },
  createTicket(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${support.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  // updateSupport(payload) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .put(`${support.base}${payload.id}/`, payload.data)
  //       .then((res) => {
  //         resolve(handleResponse(res));
  //       })
  //       .catch((err) => {
  //         reject(handleError(err));
  //       });
  //   });
  // },
  addTicketAttachment(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${support.document}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTicketAttachmentList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${support.document}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTicketCommentList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${support.comment}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  setRemainder(id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${support.base}${id}/sent_reminder/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  sendComment(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${support.comment}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getSupportLogs(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${support.logs}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
